import React from "react";
import CustomInput from "Common/CustomInput/CustomInput";
import PropTypes from "prop-types";

const Address = ({
  ptModel,
  validationModel,
  handleChange,
  onPasteZip,
  hasInsuranceDataStarted,
}) => {
  return (
    <div className="space-y-4 mt-4">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 md:col-span-12">
          <CustomInput
            onChange={handleChange}
            name="address1"
            value={ptModel.address1}
            required={hasInsuranceDataStarted()}
            label="Street Address"
            placeholder="Street Address"
            toLower
          />
          {validationModel.address1Error}
        </div>
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 md:col-span-4">
          <CustomInput
            name="city"
            value={ptModel.city}
            disabled={true}
            label="City"
            placeholder="City"
            toLower
            toolTip="City and State will appear automatically once you enter a valid Zip Code."
          />
        </div>
        <div className="col-span-12 md:col-span-4">
          <CustomInput
            name="state"
            value={ptModel.state}
            disabled={true}
            label="State"
            placeholder="State"
          />
        </div>
        <div className="col-span-12 md:col-span-4">
          <CustomInput
            onInput={onPasteZip}
            label="Zip Code"
            placeholder="Zip Code"
            name="zipCode"
            onChange={handleChange}
            required={hasInsuranceDataStarted()}
            isNumeric
            maxlength="9"
            value={ptModel.zipCode}
          />
          {validationModel.zipCodeError}
        </div>
      </div>
    </div>
  );
};

Address.propTypes = {
  ptModel: PropTypes.object.isRequired,
  validationModel: PropTypes.object.isRequired,
  sectionsOpen: PropTypes.object.isRequired,
  onToggleSection: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPasteZip: PropTypes.func.isRequired,
  hasInsuranceDataStarted: PropTypes.func.isRequired,
};

export default Address;
